import apiHandler from "../apiHandler";
import { Client } from "pages/Client/types";

export const _getClients = async (): Promise<Array<Client>> => {
  return apiHandler.get<Array<Client>>(
    "ClientInformations"
  );
};

export const _getClientHierarchyData = async () => {
  return apiHandler.get<Array<Client>>(
    "HierarchyData"
  );
};

export const _addClient = async (formData: FormData) => {
   return apiHandler.post<any>("Client", formData,'form');
};

export const _updateClientInformation = async (formData: FormData) => {
     return apiHandler.put<any>("updateClientInformation", formData,'form');
};

export const _deleteClient = async (clientId: number) => {
  return apiHandler.delete("ClientInformation/" + clientId);
};